<template>
  <project-form v-if="!project_id || loaded" />
  <error-view v-else-if="error" :error="error" @reload="load" />
  <vpreloader v-else width="2" size="64" />
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import ErrorView from '@/process/_components/error-view';
  import { TALENTQ_STORE_NAMES } from '@/stores_new/vacancy_talentq/constants';
  import ProjectForm from './project-form';

  export default {
    name: 'ProjectEditor',

    components: {
      ProjectForm,
      ErrorView
    },

    computed: {
      ...mapGetters('vacancy_talentq/' + TALENTQ_STORE_NAMES.PROJECT, [
        'loaded',
        'error',
        'project_id'
      ])
    },

    created() {
      this.load();
    },

    methods: {
      ...mapActions('vacancy_talentq/' + TALENTQ_STORE_NAMES.PROJECT, ['load'])
    }
  };
</script>
